import Card from "components/card";
import CardMenu from "components/card/CardMenu";
import SwitchField from "components/fields/SwitchField";
import React from "react";

function Notification() {
  return (
    <Card extra={"w-full h-full p-3"}>
      <div className="relative mb-3 flex items-center justify-between pt-1">
        <h4 className="text-xl font-bold text-theme-700 dark:text-white">
          Notifications
        </h4>
        <CardMenu />
      </div>
      <div className="flex flex-col">
        {/* the custom checkbox desing added in src/index.js */}
        <div className="mt-3 flex items-center gap-3">
          <SwitchField id="switch1" />
          <label
            for="checkbox1"
            className="text-base font-medium text-theme-700 dark:text-white"
          >
            Item comment notifications
          </label>
        </div>

        <div className="mt-4 flex items-center gap-3">
          <SwitchField id="switch2" />
          <label
            for="checkbox2"
            className="text-base font-medium text-theme-700 dark:text-white"
          >
            Buyer review notifications
          </label>
        </div>

        <div className="mt-4 flex items-center gap-3">
          <SwitchField id="switch3" />
          <label
            for="checkbox3"
            className="text-base font-medium text-theme-700 dark:text-white"
          >
            Rating reminders notifications
          </label>
        </div>

        <div className="mt-4 flex items-center gap-3">
          <SwitchField id="switch4" />
          <label
            for="checkbox4"
            className="text-base font-medium text-theme-700 dark:text-white"
          >
            Meetups near you notifications
          </label>
        </div>

        <div className="mt-4 flex items-center gap-3">
          <SwitchField id="switch5" />
          <label
            for="checkbox5"
            className="text-base font-medium text-theme-700 dark:text-white"
          >
            Company news notifications
          </label>
        </div>

        <div className="mt-4 flex items-center gap-3">
          <SwitchField id="switch6" />
          <label
            for="checkbox6"
            className="text-base font-medium text-theme-700 dark:text-white"
          >
            New launches and projects
          </label>
        </div>
        <div className="mt-4 flex items-center gap-3">
          <SwitchField id="switch7" />
          <label
            for="checkbox7"
            className="text-base font-medium text-theme-700 dark:text-white"
          >
            Monthly product changes
          </label>
        </div>
        <div className="mt-4 flex items-center gap-3">
          <SwitchField id="switch8" />
          <label
            for="checkbox8"
            className="text-base font-medium text-theme-700 dark:text-white"
          >
            Subscribe to newsletter
          </label>
        </div>
        <div className="mt-4 flex items-center gap-3">
          <SwitchField id="switch8" />
          <label
            for="checkbox8"
            className="text-base font-medium text-theme-700 dark:text-white"
          >
            Email me when someone follows me
          </label>
        </div>
      </div>
    </Card>
  );
}

export default Notification;
